<template>
  <div class="invoice">
    <div class="apply-invoice" @click="applyInvoice">申请开票</div>

    <el-dialog
      title="系统提示"
      :visible.sync="dialogvis.identifyShop"
      width="400px">
      <p style="font-size:16px;text-align:center;margin:10px 0 0;font-weight:bold;line-height:24px">已认证店铺才可申请开票，</p>
      <p style="font-size:16px;text-align:center;font-weight:bold;line-height:24px">您的店铺暂未认证，请前往认证。</p>
      <div class="use-btn">
        <button class="my-button" @click="toIndentifyShop">去认证</button>
        <button class="my-button-cancel" @click="dialogvis.identifyShop = false">取消</button>
      </div>
    </el-dialog>

    <el-table 
    :data="dataList"
    v-scrollListen="{el: '.el-table__body-wrapper', fn: scrollLoad}"
    v-loading="tableLoading"
    highlight-current-row
    height="100%"
    style="width:100%">
      <el-table-column label="#" width="50" type="index" align="center"></el-table-column>
      <el-table-column label="申请时间" width="124">
        <template slot-scope="scope">
          <p>{{scope.row.create_time.split(' ')[0]}}</p>
          <p>{{scope.row.create_time.split(' ')[1]}}</p>
        </template>
      </el-table-column>
      <el-table-column label="申请人" min-width="157">
        <template slot-scope="scope">
          <p class="text-popper" v-textPopper>
            <head-img :avatar="scope.row.user_info.headimgurl" :sex="scope.row.user_info.sex" :radius="true"></head-img>
            <span class="nickname">{{scope.row.user_info.nickname}}</span>
          </p>
        </template>
      </el-table-column>
      <el-table-column label="开票金额(元)" width="110" prop="record_code" align="right">
        <template slot-scope="scope">
          <span>{{totalMoney(scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="购买服务/商品" min-width="186">
        <template slot-scope="scope">
          <span class="text-popper" v-textPopper>{{totalServer(scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="91" align="right">
        <template slot-scope="scope">
          <p v-if="scope.row.status" class="green">已处理</p>
          <p v-else class="red">待处理</p>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="60" align="center">
        <template slot-scope="scope">
          <el-button type="text" class="clink" @click="detail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <el-button type="text" v-if="scope.row.status" class="clink" @click="downloadInvoice(scope.row)">下载发票</el-button>
        </template>
      </el-table-column>
      <p slot="append" style="text-align:center;padding:10px;" v-if="tableLoading">{{MIXIN_TableLodingText}}</p>
      <p slot="append" style="text-align:center;padding:10px;color:#999;" v-if="!isTableDataHasMore">没有更多了</p>
    </el-table>

    <apply-invoice-list ref="applyInvoiceList" @updateRecord="updateRecord"></apply-invoice-list>
    <invoice-detial ref="invoiceDetial"></invoice-detial>
  </div>
</template>

<script>
import applyInvoiceList from './applyInvoiceList'
import invoiceDetial from './invoiceDetial'

export default {
  data() {
    return {
      dataList: [], // 付费记录的列表
      dialogvis: {
        identifyShop: false, // 店铺认证的dialog的显示与隐藏
      },
      shopAuth: {}, // 店铺认证信息
      invoiceList: [], // 发票文件详情
    }
  },

  created() {
    this.init()
  },

  methods: {
    /**
     * 初始化
     */
    init() {
      if(this.$route.query.shop_id && this.$route.query.shop_type && this.$route.query.shop_name && this.$route.query.shop_super_admin_passport_id) {
        this.getTableList()
        this.getAuthInfo()
      }
    },

    /**
     * 获取发票列表
     * @param {number} page 页数，默认为0
     */
    getTableList(page = 0) {
      this.tableLoading = true
      return this.$fetch.post({
        url: '/invoiceticket?method=get_invoice_ticket_list',
        params: {
          shop_id: this.$route.query.shop_id,
          shop_type: this.$route.query.shop_type,
          page: page,
          pagesize: 20,
        }
      }).then(res => {
        let hasMore = res.has_more
        let data = []
        if (res.invoice_ticket_infos.length === 0) {
          return { data: null, has_more: false }
        }
        data = res.invoice_ticket_infos.map(item => {
          return item
        })
        if(page === 0) {
          this.dataList = data
          this.initScrollTable(hasMore)
        } else {
          this.dataList = this.dataList.concat(data)
        }
        return { data, has_more: hasMore }
      }).catch(e => {
        this.openMessage(0, e.error_text || "获取市场列表失败")
      }).finally(() => {
        this.tableLoading = false
      })
    },

    /**
     * 获取店铺认证信息
     */
    getAuthInfo() {
      this.$fetch.post({
        url: '/authenticate?method=get_authenticate_info',
        params: {
          shop_id: this.$route.query.shop_id,
          shop_type: this.$route.query.shop_type,
        }
      }).then(res => {
        // has_done 为1代表已通过。
        if(res.data && res.data.has_done === 1) {
          this.shopAuth = res.data
          this.$route.query.shop_super_admin_passport_id = res.data.passport_id
        } else {
          this.shopAuth = null
        }
      }).catch(e => {
        this.openMessage(0, e.error_text || '获取店铺认证信息失败')
      })
    },

    /**
     * 下载发票
     * @param {Object} item 所点击行的对象
     */
    downloadInvoice(item) {     
      this.$fetch.post({
        url: '/common/qiniu?method=get_download_file_url',
        params: {
          key: item.ticket_url
        }
      }).then(res => {
        window.open(res.private_url)
      })
    },

    /**
     * 查看详情
     * @param {Object} item 对象详情
     */
    detail(item) {
      this.$refs.invoiceDetial.open(item)
    },

    /**
     * 申请开发票
     */
    applyInvoice() {
      this.openMessage(0, '功能升级中，请联系客服申请开票') // 暂时屏蔽申请开票，以下代码请勿删除
      // if(this.shopAuth) {
      //   this.$refs.applyInvoiceList.open(this.shopAuth.shop_company_name, this.shopAuth.shop_uscc)
      // } else {
      //   this.dialogvis.identifyShop = true
      // }
    },

    /**
     * 去认证店铺信息
     */
    toIndentifyShop() {
      this.$router.push({
        name: 'shopApply',
        query: {
          ...this.$route.query
        }
      })
    },

    /**
     * 格式化钱的显示，已**.**的格式显示
     * @param {number} value
     */
    formatterMoney(value) {
      if (String(value).includes(".")) {
        if (String(value).split(".")[1].length === 2) {
          return `${value}`;
        } else if (String(value).split(".")[1].length === 1) {
          return `${value}0`;
        } else {
          return value.toFixed(2)
        }
      } else {
        return `${value}.00`;
      }
    },

    /**
     * 统计每个发票的总价
     * @param {Array} array 每个发票中包含的费用的列表
     */
    totalMoney(array) {
      if(Array.isArray(array.fee_record_infos)) {
        return this.formatterMoney(array.fee_record_infos.reduce((total, cur) => total += cur.pay_money, 0))
      } else {
        return ''
      }
    },

    /**
     * 统计每个发票所购买的商品种类
     * @param {Array} array 每个发票中包含的费用的列表
     * @return {String} 
     */
    totalServer(array) {
      if(Array.isArray(array.fee_record_infos)) {
        let servers = [];
        array.fee_record_infos.map(item => {
          const paymentDetail = item.payment_detail || {}
          const claimItem = paymentDetail.claim_item || {}
          const goodsItem = claimItem.payment_target_detail || item.fee_info.goods_item
          if(!servers.includes(goodsItem)){
            servers.push(goodsItem)
          }
        })
        return servers.join('、')
      } else {
        return ''
      }
    },

    /**
     * 提交完开票申请后，更新开票记录
     * @param {Boolean} update 是否更新开票记录
     */
    updateRecord(update) {
      if(update) {
        this.getTableList(0)
      }
    },
  },

  components: {
    applyInvoiceList,
    invoiceDetial,
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-drawer__header {
  margin-bottom: 0;
}

.invoice {
  position: relative;
  height: calc(100% - 103px);
  width: 1020px;
  margin: 0 auto;

  /deep/ .el-table {
    margin: 0;
  }

  .apply-invoice {
    position: absolute;
    top: -53px;
    right: 0;
    width: 56px;
    height: 40px;
    z-index: 999;
    color: #3c90ff;
    font-size: 14px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
  }

  .use-btn {
    margin-top: 20px;
    
    .my-button {
      margin-right: 10px;
    }
  }

  .nickname {
    padding-left: 4px;
  }
  .red {
    color: #e51c23;
  }
  .green {
    color: #08A681;
  }
}
</style>
